const commonStyle = 'padding: 0 5px;margin-right: 2px;';
const headingStyleFactory = (backgroundColor) => commonStyle + `border: 1px solid ${backgroundColor};background: ${backgroundColor};color: white;`
const messageStyle = commonStyle + '';

enum LogLevel {
    info = "INFO",
    warn = "WARN",
    debug = "DEBUG",
    error = "ERROR"
}

const logStyles = {
    [LogLevel.info]: commonStyle + 'background #efe; color: green;border: 1px dashed #ccc;',
    [LogLevel.warn]: commonStyle + 'background #efe; color: orange;border: 1px dashed #ccc;',
    [LogLevel.debug]: commonStyle + 'background #efe; color: blue;border: 1px dashed #ccc;',
    [LogLevel.error]: commonStyle + 'background #efe; color: red;border: 1px dashed #ccc;'
}

export class Logger {
    public static logLevel: LogLevel;
    private readonly _prefixes: string;
    private readonly _styles: string[];

    private constructor(prefixMessage: string, ...styles: string[]) {
        this._prefixes = prefixMessage;
        this._styles = styles;
    }

    static createInstance(serviceName, color = "green") {
        const headingStyle = headingStyleFactory(color);
        return new Logger(`%c${serviceName}`,headingStyle);
    }

    withPrefix(prefix: string, color = "green") {
        const headingStyle = headingStyleFactory(color);
        return new Logger(`${this._prefixes}%c${prefix}`, ...this._styles, headingStyle);
    }

    info(message, ...args) {
        this.log(LogLevel.info, message,  ...args);
    }


    warn(message, ...args) {
        this.log(LogLevel.warn, message,  ...args);
    }

    debug(message, ...args) {
        this.log(LogLevel.debug, message,  ...args);

    }

    error(message, ...args: any) {
        this.log(LogLevel.error, message,  ...args);
    }

    log(level: LogLevel, message: string, ...args: any) {
        console.log(`${this._prefixes}%c${level}%c${message}`, ...this._styles, logStyles[level], messageStyle,  ...args.map(arg => ({ data: arg })));
    }
}
